import Vue from "vue";
import Vuetify from "vuetify/lib";
import "vuetify/dist/vuetify.min.css";
import whitelabel from "../whitelabel-config";

const light = whitelabel(process.env.VUE_APP_BRAND).colors;

Vue.use(Vuetify);

const opts = {
  icons: {
    iconfont: "mdiSvg",
  },
  theme: {
    options: {
      customProperties: true,
    },
    themes: {
      light,
    },
  },
  typography: {
    font: {
      family: 'Montserrat, sans-serif',
    },
  },
};

export default new Vuetify(opts);
